<template>
  <div class="about">
    <Header 
      title="Ranking do mês" 
      subtitle="de partidas 5x5"
    ></Header>
    <div class="container">
      <div class="stats-table table-responsive">
        <table class="table is-hoverable">
          <thead>
            <tr>
              <th>#</th>
              <th><abbr title="Nome">Nome</abbr></th>
              <th><abbr title="Total Kills">Matou</abbr></th>
              <th><abbr title="Total Mortes">Morreu</abbr></th>
              <th><abbr title="KDR MEDIO">KDR</abbr></th>
              <th><abbr title="KPR MEDIO">KPR</abbr></th>
              <th><abbr title="ADR MEDIO">ADR</abbr></th>
              <th><abbr title="QUEOTA.club score">Score</abbr></th>
              <th><abbr title="Vitorias/Derrotas Totais">W/L</abbr></th>
              <th><abbr title="Rounds">Rounds</abbr></th>
              <th><abbr title="First Kills">FK</abbr></th>
              <th><abbr title="Trades">Trades</abbr></th>
              <th><abbr title="HS % MEDIO">HS %</abbr></th>
              <th><abbr title="bomb_plants">c4</abbr></th>
              <th><abbr title="partidas">partidas</abbr></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(player, index) in players" :key="player.id">
              <td>{{index+1}}</td>
              <td v-if="player.user" class="user-column">
                <router-link :to="{ name: 'UserSingle', params: { id: player.user.id }}">
                  <div class="user-image">
                    <b-img-lazy rounded="circle" :src="player.user.avatar" :alt="player.nickname" v-if="player.user.avatar" />
                  </div>
                  <span>{{ player.user.nickname }}</span>
                </router-link>
              </td>
              <td v-if="!player.user">{{ player.name }}</td>
              <td>{{ player.kills }}</td>
              <td>{{ player.deaths }}</td>
              <td>{{ player.kdr }}</td>
              <td>{{ player.kpr }}</td>
              <td>{{ player.adr }}</td>
              <td>
                <strong>
                  {{ player.queota_score }}
                </strong>
              </td>
              <td>{{ player.total_wins }}/{{ player.total_losses }}</td>
              <td>{{ player.rounds_played }}</td>
              <td>{{ player.firstkills }}</td>
              <td>{{ player.tradekills }}</td>
              <td>{{ player.headshot_percentage }}%</td>
              <td>{{ player.bomb_plants }}</td>
              <td>{{ player.matches_played }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'RankedStats',
  metaInfo: {
    title: 'Ranked Competitiva'
  },
  data () {
    return {
      players: null
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('ranked_stats.json')
        .then(response => (this.players = response.data))
      
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    Header
  }
}
</script>

<style lang="sass" scoped>
.stats-table table
  background: transparent
.user-column
  // display: flex
  padding: 0.5em 0.45em !important
  .user-image
    display: inline-block
    margin-right: 10px
    img
      width: 28px
      height: 28px
  span
    display: inline-block
    position: relative
    top: 3px
</style>
